import React, { FormEvent } from "react";
import "./InternshipApplicationPage.css";

const InternshipApplicationPage = () => {
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    //TODO the form is not sent anywhere
  }
  return (
    <div className="content-container internship-application-container">
      <div className="wrapper-card green">
        <h1>Internship Application</h1>
        <form className="internship-application-form" onSubmit={handleSubmit}>
          <div className="internship-form-input-with-label">
            <label htmlFor="first-name">First Name*</label>
            <input type="text" name="firstName" id="first-name" required />
          </div>
          <div className="internship-form-input-with-label">
            <label htmlFor="last-name">Last Name*</label>
            <input type="text" name="lastName" id="last-name" required />
          </div>{" "}
          <div className="internship-form-input-with-label">
            <label htmlFor="email">Email*</label>
            <input type="email" name="email" id="email" required />
          </div>
          <div className="internship-form-input-with-label">
            <label htmlFor="reasoning">
              Why do you want to be an intern at Alnarp's Farm? Answer with a
              short sentence.*
            </label>
            <input type="text" name="reasoning" id="reasoning" required />
          </div>
          <div className="internship-form-input-with-label">
            <label htmlFor="reasoning">
              What is the minimum and maximum length you can realistically
              commit to, and why? Mention the months you are interested in.*
            </label>
            <textarea name="reasoning" id="reasoning" required />
          </div>
          <fieldset>
            <legend>
              Do you currently have the legal right to stay in Sweden for the
              full duration of the internship?*
            </legend>
            <div className="internship-form-input-with-label">
              <label>
                <input type="radio" name="swedishPermit" value="yes" required />
                Yes
              </label>
            </div>{" "}
            <div className="internship-form-input-with-label">
              <label>
                <input type="radio" name="swedishPermit" value="no" />
                No
              </label>
            </div>{" "}
            <div className="internship-form-input-with-label">
              <label>
                <input type="radio" name="swedishPermit" value="willApply" />I
                will have to apply for a visa
              </label>
            </div>
          </fieldset>
          <div className="internship-form-input-with-label">
            <label htmlFor="accomodation">
              Living expenses in Sweden are estimated at 800–1000€ per month.
              (Accommodation, food, transport, insurance, personal expenses) -
              Are you aware of this, and how do you plan to cover your
              expenses?*
            </label>
            <textarea name="accomodation" id="accomodation" required />
          </div>
          <div className="internship-form-input-with-label">
            <label htmlFor="university">
              Is this internship part of your studies? Which University do you
              come from?*
            </label>
            <input type="text" name="university" id="university" required />
          </div>
          <div className="internship-form-input-with-label">
            <label htmlFor="experience">
              Tell us about a time you were physically uncomfortable or
              exhausted while working. What was the situation and how did you
              react?*
            </label>
            <textarea name="experience" id="experience" required />
          </div>
          <div className="internship-form-input-with-label">
            <label htmlFor="self-improvement">
              What is something you are currently trying to improve about
              yourself?*
            </label>
            <textarea name="selfImprovement" id="self-improvement" required />
          </div>
          <label className="internship-form-checkbox-label">
            <input
              className="internship-form-checkbox"
              type="checkbox"
              name="terms"
              required
            />
            * I understand that:
            <ul>
              <li>
                This internships is unpaid and we don't provide accommodation
              </li>{" "}
              <li>We do not provide visa documents</li>{" "}
              <li>The work can be physically demanding</li>
            </ul>
          </label>
          <label>
            * Please upload a 2 minute video video where you:
            <ul>
              <li>Introduce yourself</li>
              <li>Say why you want to come to our farm</li>{" "}
              <li>What you hope to learn</li>
            </ul>
            <input type="file" name="file" required />
          </label>{" "}
          <br /> <br />
          <button className="btn internship-submition-btn" type="button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default InternshipApplicationPage;
